// @flow
import React, {Fragment, PureComponent, type ComponentType} from 'react';
import BrandConsolidationBanner from '@homeaway/react-brand-consolidation';
import ReactResizeDetector from 'react-resize-detector';
import CovidBanner from '../CovidBanner/CovidBanner';
import GDPRBanner from '../GDPRBanner/GDPRBanner';

import type {Size} from '../../actions/topBanners';
import type {State as AbacusState} from '../../reducers/abacus';
import type {SystemData} from '../../../server/utils/systemData';

import './withTopBanners.less';

export type Props = {
    onTopBannersSizeChanged: (Size) => any,
    abacus: AbacusState,
    siteName: string,
    fullLocale: string,
    showConsolidationBanner: boolean,
    system: SystemData,
    onResize: Function
};

export default function withTopBanners<OwnProps: {}>(
    WrappedComponent: ComponentType<$Supertype<OwnProps>>
): ComponentType<Props> {
    return class TopBanners extends PureComponent<Props> {
        getGDPRBannerVersion = () => {
            const {
                abacus: {ha_gdpr_banner: experiment}
            } = this.props;

            if (
                experiment &&
                experiment.bucket &&
                experiment.bucket.bucketConfig
            ) {
                const {
                    bucket: {bucketConfig}
                } = experiment;

                return bucketConfig;
            }

            return null;
        };

        onResize = (width, height) => {
            this.props.onTopBannersSizeChanged({
                height
            });
        };

        render() {
            const {siteName, fullLocale, showConsolidationBanner} = this.props;
            const gdprBannerVersion = this.getGDPRBannerVersion();

            return (
                <Fragment>
                    <div className="TopBanners">
                        {gdprBannerVersion && (
                            <GDPRBanner
                                fullLocale={fullLocale}
                                bannerVersion={gdprBannerVersion}
                            />
                        )}
                        {showConsolidationBanner && (
                            <BrandConsolidationBanner siteName={siteName} />
                        )}
                        <CovidBanner />
                        <ReactResizeDetector
                            handleHeight
                            onResize={this.onResize}
                        />
                    </div>
                    <WrappedComponent {...this.props} />
                </Fragment>
            );
        }
    };
}
